import { notify } from '../../../app';
import { getInboundNumbers } from '../../../api';
import { addInboundPhoneNumber } from '../../../api';
import { useFetch, useRequest } from '../../../hooks';
import { deleteInboundPhoneNumber } from '../../../api';
import type { InboundPhoneNumberType } from '../../../api';

export type AgentTelephonyFormType = {
  inboundPhones: InboundPhoneNumberType[];
};

export type PhoneType = InboundPhoneNumberType;

export const useAgentTelephony = (agentId: string) => {
  const {
    intializing: loadingInbound,
    data: inboundPhones,
    refresh: refreshInbound,
  } = useFetch(() => getInboundNumbers(agentId), [agentId]);

  const loading = loadingInbound;

  const form: AgentTelephonyFormType = {
    inboundPhones: inboundPhones || [],
  };

  const [addInboundPhonenumber, addingInbound] = useRequest(
    async (_signal, phoneNumber: string) => {
      const res = await addInboundPhoneNumber(agentId, { phoneNumber });
      return res.id;
    },
    {
      deps: [agentId],
      onSuccess: () => {
        notify.success('Added phone number');
        refreshInbound?.();
      },
      onError: () => notify.error('Failed to add phone number'),
    }
  );

  const [deleteInboundPhonenumber, deletingInbound] = useRequest(
    (_signal, phone: PhoneType) => deleteInboundPhoneNumber(agentId, phone),
    {
      deps: [agentId],
      onSuccess: () => {
        notify.success('Deleted phone number');
        refreshInbound?.();
      },
      onError: () => notify.error('Failed to delete phone number'),
    }
  );

  const updating = addingInbound || deletingInbound;

  return {
    form,
    loading,
    updating,

    addInboundPhonenumber,
    deleteInboundPhonenumber,
  };
};
